<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true" size="xl" >
        <div class="container-fluid pl-0 pr-0" style="min-height: 500px;">
            <div class="row">
                <div class="col-12 table-responsive">
                    <h4 class="card-title text-center"><b>{{ autoDto.makerFirmName}} {{autoDto.name}}</b></h4>
                    <h4 class="card-title text-center"><b>{{$t("auto.autoCorrectionTypeLabel")}}</b></h4>
                    <div class="card">
                      <div class="table-wrapper">
                        <table class="table">
                            <tr>
                                <th class="text-center">Омиллар</th>
                                <th class="text-center" width="20%">Харажат ёндашуви %</th>
                                <th class="text-center" width="20%">Киёсий ёндашуви %</th>
                            </tr>
                            <tr>
                                <td>
                                    <b>Ҳисоблаб топилган кийматлар, Сум</b>
                                </td>
                                <td align="center">
                                    <b>{{autoDto.totalGovPrice | currency('', 0, { thousandsSeparator: ' ' })}} сўм </b>
                                </td>
                                <td align="center">
                                    <b>{{autoDto.avgPrice | currency('', 0, { thousandsSeparator: ' ' })}} сўм </b>
                                </td>
                            </tr>
                            <tr v-for="(correctionType, index) in autoDto.correctionTypeDtos" :key="correctionType.id">
                                <td>
                                    {{correctionTypeEnum[index][correctionType.correctionType]}}
                                </td>
                                <td class="text-center">
                                    <span v-if="correctionType.key!=='SpecificDimensionsApproaches'">
                                        {{(correctionType.approachOnePercent/6).toFixed(2)}} %
                                    </span>
                                    <span v-if="correctionType.key==='SpecificDimensionsApproaches'">
                                        <b>{{calculated.totalOne}} %</b>
                                    </span>
                                </td>
                                <td class="text-center">
                                    <span v-if="correctionType.key!=='SpecificDimensionsApproaches'">
                                        {{(correctionType.approachThirdPercent/6).toFixed(2)}} %
                                    </span>
                                    <span v-if="correctionType.key==='SpecificDimensionsApproaches'">
                                        <b>{{calculated.totalThree}} %</b>
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="autoDto.correctionTypeDtos.length > 0">
                                <td>
                                    <b>Салмоқ бўйича қийматлар суммаси</b>
                                </td>
                                <td align="center">
                                    <b>{{calculated.totalPriceOne | currency('', 0, { thousandsSeparator: ' ' })}} сўм</b>
                                </td>
                                <td align="center">
                                    <b>{{calculated.totalPriceThree | currency('', 0, { thousandsSeparator: ' ' })}} сўм</b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Аниқланган қиймати</b>
                                </td>
                                <td align="center" colspan="2">
                                    <b>{{autoDto.evlPrice | currency('', 0, { thousandsSeparator: ' ' })}} сўм </b>
                                </td>
                            </tr>
                        </table>
                      </div>

                    </div>
                    <div class="pull-right">
                        <h4 class="card-title">
                            <b>Мувофиклаштириш кейин аниқланган қиймати: <span class="text-success">{{autoDto.evlPrice | currency('', 0, { thousandsSeparator: ' ' })}} сўм</span></b>
                        </h4>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>

    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {CORRECTION_TYPE_ENUM} from '@/shared/constants/auto'

    export default {
        name: "AutoCorrectionType",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                autoId: null,
                autoDto: {
                    correctionTypeDtos: []
                },
                correctionTypeEnum: CORRECTION_TYPE_ENUM
            }
        },
        computed: {
            calculated() {
                let differenceOfApproach;
                if (this.autoDto.totalGovPrice < this.autoDto.avgPrice)
                    differenceOfApproach = (1 - (this.autoDto.totalGovPrice/this.autoDto.avgPrice)).toFixed(4);
                else
                    differenceOfApproach = (1 - (this.autoDto.avgPrice/this.autoDto.totalGovPrice)).toFixed(4);

                return {
                    totalOne: differenceOfApproach > 0.3 ? 0.28 :(this.autoDto.correctionTypeDtos[6].approachOnePercent/6).toFixed(2),
                    totalThree: differenceOfApproach > 0.3 ? 0.72 : (this.autoDto.correctionTypeDtos[6].approachThirdPercent/6).toFixed(2),
                    totalPriceOne: (this.autoDto.totalGovPrice * this.autoDto.correctionTypeDtos[6].approachOnePercent/6),
                    totalPriceThree: (this.autoDto.avgPrice * this.autoDto.correctionTypeDtos[6].approachThirdPercent/6)
                }
            }
        },
        methods: {
            init() {
                const vm = this;
                if (this.autoId != null) {
                    this.$http.get('auto/item/' + this.autoId).then(function (data) {
                        vm.autoDto = data.data;
                    });
                }

            },
            cancel() {
                this.show = false;
            }
        },
        created() {
            this.$eventBus.$on('AutoCorrectionType', (autoId) => {
                this.show = true;
                this.autoId = autoId;
                this.init();
            });
        }
    }
</script>

<style scoped>

</style>